import { Link } from 'react-router-dom';
import { FaShippingFast, FaArrowDown, FaStore, FaFire } from 'react-icons/fa';
import Container from './Container';

const SpecialOffers = () => {
  const ADMIN_DASHBOARD_URL =
    process.env.NODE_ENV === 'production'
      ? 'https://admin.pikkodubai.com'
      : 'http://localhost:3001';
  const sellerRegisterUrl = `${ADMIN_DASHBOARD_URL}/seller-auth`;

  const cards = [
    {
      icon: <FaShippingFast className="text-[16px] text-[#059473]" />,
      iconBg: 'bg-emerald-50',
      accent: 'text-[#059473]',
      accentBorder: 'hover:border-[#059473]/40',
      badge: 'Local Warehouse',
      metric: 'From AED 1.99',
      title: 'Fast Delivery',
      desc: 'Same-day dispatch on thousands of items across the UAE.',
      cta: { label: 'Shop Now', to: '/products', external: false },
    },
    {
      icon: <FaArrowDown className="text-[16px] text-orange-500" />,
      iconBg: 'bg-orange-50',
      accent: 'text-orange-500',
      accentBorder: 'hover:border-orange-500/40',
      badge: 'Limited Time',
      metric: 'Up to 50% Off',
      title: 'Price Drop',
      desc: 'Hundreds of items at slashed prices — refreshed daily.',
      cta: { label: 'See Deals', to: '/products', external: false },
    },
    {
      icon: <FaFire className="text-[16px] text-[#E21C1B]" />,
      iconBg: 'bg-red-50',
      accent: 'text-[#E21C1B]',
      accentBorder: 'hover:border-[#E21C1B]/40',
      badge: 'Trending Now',
      metric: 'Trending Today',
      title: 'Popular Products',
      desc: 'Discover what UAE customers are buying right now.',
      cta: { label: 'Explore', to: '/products', external: false },
    },
    {
      icon: <FaStore className="text-[16px] text-indigo-600" />,
      iconBg: 'bg-indigo-50',
      accent: 'text-indigo-600',
      accentBorder: 'hover:border-indigo-600/40',
      badge: 'Sell on Pikko',
      metric: 'Sell for Free',
      title: 'Start Selling',
      desc: 'Join thousands of sellers and reach buyers across the UAE.',
      cta: { label: 'Register Now', to: sellerRegisterUrl, external: true },
    },
  ];

  const ctaClass =
    'mt-2 inline-flex items-center gap-1 text-[11px] font-semibold text-gray-900 group-hover:gap-1.5 transition-all duration-200';

  return (
    <section className="w-full py-6">
      <Container>
        <div className="grid grid-cols-4 lg:grid-cols-2 sm:grid-cols-1 divide-x lg:divide-x-0 divide-gray-200 border border-gray-200 rounded-xl bg-white">
          {cards.map((card, i) => (
            <div
              key={i}
              className={`group flex flex-col px-4 py-4 ${i > 0 ? 'lg:border-t sm:border-t border-gray-200' : ''} ${i % 2 === 1 ? 'lg:border-l lg:border-t-0' : ''} ${i === 2 ? 'lg:border-t' : ''}`}
            >
              {/* Icon + title */}
              <div className="flex items-center gap-2.5 mb-2.5">
                <div className={`w-8 h-8 rounded-full ${card.iconBg} flex items-center justify-center flex-shrink-0`}>
                  {card.icon}
                </div>
                <div>
                  <p className="text-[8px] font-semibold tracking-[0.12em] uppercase text-gray-400 mb-0.5">
                    {card.badge}
                  </p>
                  <h3 className="text-[12.5px] font-semibold text-gray-900">{card.title}</h3>
                </div>
              </div>

              {/* Metric */}
              <p className={`text-[15px] font-bold tracking-tight mb-1 ${card.accent}`}>{card.metric}</p>

              {/* Description */}
              <p className="text-[11px] text-gray-500 leading-[1.5]">{card.desc}</p>

              {/* CTA */}
              {card.cta.external ? (
                <a
                  href={card.cta.to}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={ctaClass}
                >
                  {card.cta.label}
                  <span>→</span>
                </a>
              ) : (
                <Link to={card.cta.to} className={ctaClass}>
                  {card.cta.label}
                  <span>→</span>
                </Link>
              )}
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default SpecialOffers;
